(function () {
    angular.module('emarket.main.profile').controller('ProfileMenuController', ['$scope', 'Announcer', 'Auth', 'Chat', function ($scope, Announcer, Auth, Chat) {
        var vm = this;
        var announcer = Announcer.create($scope);
        vm.messageCount = 0;
        vm.logout = function() {
            Auth.logout();
        };
        Chat.getUnreadMessageCount().then(function(response) {
            vm.messageCount = response.unread;
        });
        announcer.on(Announcer.types.CHAT_MESSAGE_RECEIVER, function() {
            vm.messageCount +=1;
        });

    }]);
}());
